import React, { Component } from "react";
import { ListaPerguntasFrequentes } from "../../services/api";
import Header from "../../components/Header";
import {
  GridCard,
  GridCardBody,
  GridCardHeader,
  GridCardHeaderControl,
  GridCardHeaderTitle,
  GridContainer,
  PerguntasFrequentesContainer,
  PerguntasFrequentesContainerContent,
  PerguntasFrequentesContainerContentHeader,
  PerguntasFrequentesContainerContentHeaderContent,
  PerguntasFrequentesContainerText,
} from "./styles";
import {
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";

class PerguntasFrequentes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dados: [],
      abrir_pergunta: [],
      pergunta_selecionada: null,
    };
  }

  componentDidMount() {
    this.initial();
  }

  initial = async () => {
    this.getLessons();
  };

  getLessons = async () => {
    try {
      const response = await ListaPerguntasFrequentes.get();
      var data = response.data;

      this.setState({ dados: data });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  AbrirDadosPergunta = async (e) => {
    var value = parseInt(e.nativeEvent.path[1].attributes.value.value);

    if (this.state.abrir_pergunta.includes(value)) {
      this.setState({ abrir_pergunta: [] });
    } else {
      this.setState({ abrir_pergunta: [value] });
    }

    // if(this.state.abrir_pergunta.includes(value)){
    //     var abrir_pergunta = []
    //     this.state.abrir_pergunta.map(data=>{
    //         if(data != value){
    //             abrir_pergunta.push(data);
    //         }
    //     });
    //     this.setState({abrir_pergunta: []});
    //     this.setState({abrir_pergunta: abrir_pergunta});
    // }else{
    //     var abrir_pergunta = this.state.abrir_pergunta;
    //     abrir_pergunta.push(value);
    //     this.setState({abrir_pergunta: []});
    //     this.setState({abrir_pergunta: abrir_pergunta});
    // }
  };

  BuscaPergunta = async (e) => {
    this.setState({ pergunta_selecionada: e.target.value });
  };

  render() {
    const { dados } = this.state;

    return (
      <>
        <PerguntasFrequentesContainer>
          <PerguntasFrequentesContainerText>
            <h1>
              PERGUNTAS <strong>FREQUENTES</strong>
            </h1>
          </PerguntasFrequentesContainerText>
          <PerguntasFrequentesContainerContent>
            <PerguntasFrequentesContainerContentHeader>
              <PerguntasFrequentesContainerContentHeaderContent>
                <InputGroup>
                  <Input
                    h="3rem"
                    autoFocus
                    bgColor= 'white'
                    borderBottomColor="#820AD1"
                    focusBorderColor="none"
                    _placeholder={{ color: "#820AD1" }}
                    _hover={{ borderBottomColor: "#820AD1" }}
                    onChange={(e) => this.BuscaPergunta(e)}
                    placeholder="Pesquisar..."
                  />
                  <InputRightElement
                    children={<SearchIcon color="#820AD1" mt="0.7rem" />}
                  />
                </InputGroup>
              </PerguntasFrequentesContainerContentHeaderContent>
            </PerguntasFrequentesContainerContentHeader>
            <GridContainer>
              {dados.map((data) => {
                if (
                  this.state.pergunta_selecionada != null &&
                  this.state.pergunta_selecionada != ""
                ) {
                  if (
                    data.pergunta
                      .toLowerCase()
                      .indexOf(this.state.pergunta_selecionada.toLowerCase()) !=
                    -1
                  ) {
                    return (
                      <GridCard
                        style={
                          this.state.abrir_pergunta.includes(
                            parseInt(data.codigo_pergunta)
                          )
                            ? { transition: "0.3s", height: "auto" }
                            : { height: "70px" }
                        }
                      >
                        <GridCardHeader
                          value={data.codigo_pergunta}
                          onClick={(e) => this.AbrirDadosPergunta(e)}
                        >
                          <GridCardHeaderTitle>
                            <p>{data.pergunta}</p>
                          </GridCardHeaderTitle>
                          <GridCardHeaderControl
                            value={data.codigo_pergunta}
                            onClick={(e) => this.AbrirDadosPergunta(e)}
                          >
                            {this.state.abrir_pergunta.includes(
                              parseInt(data.codigo_pergunta)
                            ) ? (
                              <span
                                value={data.codigo_pergunta}
                                onClick={(e) => this.AbrirDadosPergunta(e)}
                                className="icon icon-40 icon-arrow-up-gray"
                              ></span>
                            ) : (
                              <span
                                value={data.codigo_pergunta}
                                onClick={(e) => this.AbrirDadosPergunta(e)}
                                className="icon icon-40 icon-arrow-down-gray"
                              ></span>
                            )}
                          </GridCardHeaderControl>
                        </GridCardHeader>
                        <GridCardBody
                          style={
                            this.state.abrir_pergunta.includes(
                              parseInt(data.codigo_pergunta)
                            )
                              ? { transition: "0.4s", display: "block" }
                              : { display: "none" }
                          }
                        >
                          <p>{data.resposta}</p>
                        </GridCardBody>
                      </GridCard>
                    );
                  }
                } else {
                  return (
                    <GridCard
                      style={
                        this.state.abrir_pergunta.includes(
                          parseInt(data.codigo_pergunta)
                        )
                          ? { transition: "0.3s", height: "auto" }
                          : { height: "70px" }
                      }
                    >
                      <GridCardHeader
                        value={data.codigo_pergunta}
                        onClick={(e) => this.AbrirDadosPergunta(e)}
                      >
                        <GridCardHeaderTitle>
                          <p>{data.pergunta}</p>
                        </GridCardHeaderTitle>
                        <GridCardHeaderControl
                          value={data.codigo_pergunta}
                          onClick={(e) => this.AbrirDadosPergunta(e)}
                        >
                          {this.state.abrir_pergunta.includes(
                            parseInt(data.codigo_pergunta)
                          ) ? (
                            <span
                              value={data.codigo_pergunta}
                              onClick={(e) => this.AbrirDadosPergunta(e)}
                              className="icon icon-40 icon-arrow-up-gray"
                            ></span>
                          ) : (
                            <span
                              value={data.codigo_pergunta}
                              onClick={(e) => this.AbrirDadosPergunta(e)}
                              className="icon icon-40 icon-arrow-down-gray"
                            ></span>
                          )}
                        </GridCardHeaderControl>
                      </GridCardHeader>
                      <GridCardBody
                        style={
                          this.state.abrir_pergunta.includes(
                            parseInt(data.codigo_pergunta)
                          )
                            ? { transition: "0.4s", display: "block" }
                            : { display: "none" }
                        }
                      >
                        <p>{data.resposta}</p>
                      </GridCardBody>
                    </GridCard>
                  );
                }
              })}
            </GridContainer>
          </PerguntasFrequentesContainerContent>
        </PerguntasFrequentesContainer>
      </>
    );
  }
}

export default PerguntasFrequentes;
